function endWithUnit(value: string) {
	const units = ["px", "rem", "em", "%", "vh"];

	for (const unit of units) {
		if (value.endsWith(unit)) return true;
	}

	return false;
}

export function formatCssDimension(value: string | number) {
	if (typeof value === "string" && endWithUnit(value)) return value;

	return `${value}px`;
}
